import styled from "styled-components";

import { StyledEditModalContent as StyledEditLabModalContent } from "@pages/Patients/Laboratory/components/EditModal/EditModal.styled";

import { rem } from "@styles/Utilities.styled";


export const StyledEditModalContent = styled(StyledEditLabModalContent)`
  .files-wrapper {
    .ScrollAreaRoot {
      &.previous-files {
        height: ${rem(340)};
        /* outline: 1px solid red; */
      }
    }
  }
`;
